<script setup lang="ts">
async function postProcess(file: FileResource)
{
}

defineExpose({
    postProcess
});
</script>

<template>
    <div v-if="false" />
</template>
